/**
 * Development Configuration Helper
 * Handles CORS and other development environment specific issues
 */

export const isDevelopmentEnvironment = () => {
  return false;
  // Check for React development server
  const isReactDev = (
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1' ||
    window.location.port === '3000' ||
    window.location.port === '3009' ||
    window.location.port === '8080' ||
    window.location.port === '8000' ||
    process.env.NODE_ENV === 'development'
  );
  
  // Check for WordPress development environment
  const isWordPressDev = (
    typeof WooWatermark !== 'undefined' &&
    WooWatermark.ajax_url &&
    (WooWatermark.ajax_url.includes('localhost') ||
     WooWatermark.ajax_url.includes('127.0.0.1') ||
     WooWatermark.ajax_url.includes('dev.') ||
     WooWatermark.ajax_url.includes('staging.') ||
     WooWatermark.ajax_url.includes('test.'))
  );
  
  // Check for port mismatch between React app and WordPress
  const hasPortMismatch = (() => {
    try {
      if (typeof WooWatermark !== 'undefined' && WooWatermark.ajax_url) {
        const wpUrl = new URL(WooWatermark.ajax_url);
        const currentPort = window.location.port;
        const wpPort = wpUrl.port;
        
        return currentPort && wpPort && currentPort !== wpPort;
      }
    } catch (error) {
      console.warn('Error checking port mismatch:', error);
    }
    return false;
  })();
  
  return isReactDev || isWordPressDev || hasPortMismatch;
};

// Conditional logger for development environment
export const devLog = (...args) => {
  if (isDevelopmentEnvironment()) {
    console.log(...args);
  }
};

export const getImageProxyUrl = (originalUrl) => {
  // In development, we might need to proxy images through the same origin
  if (isDevelopmentEnvironment()) {
    // Check if we're on a different port than the image source
    try {
      const currentOrigin = window.location.origin;
      const imageUrl = new URL(originalUrl, currentOrigin);
      
      if (imageUrl.origin !== currentOrigin || imageUrl.port !== window.location.port) {
        devLog(`Port mismatch detected: Image from ${imageUrl.origin}:${imageUrl.port}, App on ${currentOrigin}`);
        
        // Try to construct a relative URL if possible
        if (imageUrl.hostname === window.location.hostname) {
          // Same hostname, different port - try to use relative path
          const relativePath = imageUrl.pathname + imageUrl.search + imageUrl.hash;
          devLog(`Attempting to use relative path: ${relativePath}`);
          return relativePath;
        }
      }
    } catch (error) {
      console.warn('Error parsing image URL:', error);
    }
  }
  
  return originalUrl;
};

export const getCORSStrategy = () => {
  if (isDevelopmentEnvironment()) {
    return 'aggressive'; // Try multiple CORS strategies
  }
  return 'standard'; // Use standard CORS handling
};

export const logDevelopmentInfo = () => {
  if (isDevelopmentEnvironment()) {
    devLog('🔧 Development Environment Detected');
    devLog('📍 Current Origin:', window.location.origin);
    devLog('🌐 Hostname:', window.location.hostname);
    devLog('🔌 Port:', window.location.port);
    devLog('📱 User Agent:', navigator.userAgent);
    
    // Check if we're in a WordPress environment
    if (typeof WooWatermark !== 'undefined') {
      devLog('📝 WooWatermark Plugin Detected');
      devLog('🔗 AJAX URL:', WooWatermark.ajax_url);
      devLog('🎨 Assets URL:', WooWatermark.assets_url);
      
      // Check for port mismatch
      try {
        const wpUrl = new URL(WooWatermark.ajax_url);
        const currentPort = window.location.port;
        const wpPort = wpUrl.port;
        
        if (currentPort && wpPort && currentPort !== wpPort) {
          console.warn('⚠️  PORT MISMATCH DETECTED!');
          console.warn(`   React App: ${window.location.origin}`);
          console.warn(`   WordPress: ${wpUrl.origin}`);
          console.warn('   This will cause CORS issues with images.');
          console.warn('   Solutions:');
          console.warn('   1. Run React app on same port as WordPress');
          console.warn('   2. Add CORS headers to WordPress server');
          console.warn('   3. Use a proxy in development');
        }
      } catch (error) {
        console.warn('Error checking WordPress URL:', error);
      }
    }
  }
};
